import { Component, Input } from '@angular/core';
import { ChangeTimeIconComponent } from './icons/change-time-icon/change-time-icon.component';
import { ChangeAddressIconComponent } from './icons/change-address-icon/change-address-icon.component';
import { AddInstructionsIconComponent } from './icons/add-instructions-icon/add-instructions-icon.component';
import { ReciipientDetailsIconComponent } from './icons/reciipient-details-icon/reciipient-details-icon.component';
import { EditOrderFlowTypes, EditOrderService, MenuOption } from '../../../services/edit-order.service';

@Component({
  selector: 'common-edit-order-initial-menu',
  templateUrl: './edit-order-initial-menu.component.html',
  styleUrls: ['./edit-order-initial-menu.component.scss'],
})
export class EditOrderInitialMenuComponent {
  @Input() brandColor!: string;
  menuOptions: MenuOption[] = [
    {
      iconComponent: ChangeTimeIconComponent,
      title: 'Change delivery date & time',
      action: EditOrderFlowTypes.ChangeDateAndTime,
    },
    {
      iconComponent: ChangeAddressIconComponent,
      title: 'Deliver to a different address',
      action: EditOrderFlowTypes.ChangeAddress,
    },
    {
      iconComponent: AddInstructionsIconComponent,
      title: 'Leave delivery instructions',
      action: EditOrderFlowTypes.AddInstructions,
    },
    {
      iconComponent: ReciipientDetailsIconComponent,
      title: 'Change recipient details',
      action: EditOrderFlowTypes.ChangeRecipientDetails,
    },
  ];

  constructor(private editOrderService: EditOrderService) {}

  startStepper(flowType: EditOrderFlowTypes | any) {
    this.editOrderService.startStepper.emit(flowType);
  }

  protected readonly EditOrderFlowTypes = EditOrderFlowTypes;
}
